import { motion } from 'framer-motion';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  gradient?: boolean;
  centered?: boolean;
}

export const SectionTitle = ({
  title,
  subtitle,
  gradient = false,
  centered = false
}: SectionTitleProps) => {
  return (
    <div className={`mb-12 ${centered ? 'text-center' : ''}`}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2
          className={`text-4xl md:text-5xl font-bold mb-4 ${
            gradient ? 'gradient-text' : 'text-gray-900 dark:text-dark-50'
          }`}
        >
          {title}
        </h2>

        {/* Animated underline */}
        <motion.div
          className={`h-1 bg-gradient-to-r from-primary-500 to-secondary-500 rounded-full ${
            centered ? 'mx-auto' : ''
          }`}
          initial={{ width: 0 }}
          whileInView={{ width: centered ? '100px' : '120px' }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        />

        {subtitle && (
          <motion.p
            className="text-gray-600 dark:text-dark-300 text-lg mt-4 max-w-2xl"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            {subtitle}
          </motion.p>
        )}
      </motion.div>
    </div>
  );
};
